
export default "/assets/user-minus-micro.fee24490.svg"